module.exports = __webpack_public_path__ + "static/media/Local.658b8302.svg";